// extracted by mini-css-extract-plugin
export default {"card":"Client_card__Fahwd","text":"Client_text__mogYL","imageContainer":"Client_imageContainer__rN-sT","image":"Client_image__ykYNE","title":"Client_title__+HvM5 h2"};